export const minRemittanceAccountsColumnWidth = {
  paymentNumber: 150,
  createdAt: 105,
  updatedAt: 105,
};
